import Vue from 'vue';
import VueRouter from 'vue-router';
import FormSelectPayment from '@/components/forms/FormSelectPayment.vue';
import PaymentPix from '@/views/payment/PaymentPix.vue';
import Register from '../views/register/Register.vue';
import InternalRegister from '../views/internal-register/InternalRegister.vue';
import Program from '../views/program/Program.vue';
import SelectPayment from '../views/payment/SelectPayment.vue';
import PaymentBillet from '../views/payment/PaymentBillet.vue';
import PaymentCreditCard from '../views/payment/PaymentCreditCard.vue';
import Success from '../views/success/Success.vue';
import SuccessDefault from '../views/success/SuccessDefault.vue';
import SuccessBillet from '../views/success/SuccessBillet.vue';
import Page404 from '../views/404/404.vue';
import AuthGuard from '../guards/auth-guard';
import SubscriptionGuard from '../guards/subscription-guard';
import Subscription from '../views/subscription/Subscription.vue';
import SubscriptionError from '../views/subscription/SubscriptionError.vue';
import SubscriptionSuccess from '../views/subscription/SubscriptionSuccess.vue';
import SubscriptionSuccessGuard from '../guards/subscription-success-guard';
import RenewalGuard from '../guards/renewal-guard';
import InternalRegisterGuard from '../guards/internal-register-guard';
import SuccessInternalRegister from '../views/success/SuccessInternalRegister.vue';
import GenericError from '../views/errors/GenericError.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    redirect: { name: 'erro' }
  },
  {
    path: '/pagina-nao-encontrada',
    name: 'erro',
    component: Page404
  },
  {
    path: '/erro-assinatura',
    name: 'subscription-error',
    component: SubscriptionError
  },
  {
    path: '/erro',
    name: 'generic-error',
    component: GenericError
  },
  {
    path: '/assinatura/sucesso',
    name: 'subscription-success',
    beforeEnter: SubscriptionSuccessGuard,
    component: SubscriptionSuccess
  },
  {
    path: '/assinatura/:hash',
    beforeEnter: SubscriptionGuard,
    component: Subscription
  },
  {
    path: '/renovacao/:hash',
    beforeEnter: RenewalGuard
  },
  {
    path: '/:programId',
    beforeEnter: AuthGuard,
    component: Program,
    redirect: '/:programId/cadastro',
    children: [
      {
        path: 'cadastro',
        name: 'register',
        component: Register
      },
      {
        path: 'pagamento',
        component: SelectPayment,
        children: [
          {
            path: '',
            name: 'selecionar-pagamento',
            component: FormSelectPayment
          },
          {
            path: 'boleto',
            name: 'bank_slip',
            component: PaymentBillet
          },
          {
            path: 'parcelado',
            name: 'credit_card',
            component: PaymentCreditCard
          },
          {
            path: 'mensal',
            name: 'subscription',
            component: PaymentCreditCard
          },
          {
            path: 'pix',
            name: 'pix',
            component: PaymentPix
          }
        ]
      },
      {
        path: 'sucesso',
        component: Success,
        children: [
          {
            path: '',
            name: 'sucesso',
            component: SuccessDefault
          },
          {
            path: 'boleto',
            name: 'sucesso-boleto',
            component: SuccessBillet
          }
        ]
      }
    ]
  },
  {
    path: '/:programId/cadastro-interno',
    component: InternalRegister,
    beforeEnter: InternalRegisterGuard
  },
  {
    path: '/:programId/cadastro-interno/sucesso',
    name: 'success-internal-register',
    component: SuccessInternalRegister
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
